import React from 'react';
import ScrapeSettings from "./ScrapeSettings.tsx";
import Embeddings from "./Embeddings.tsx";
import SectionSeparator from "../../Subcomponents/SectionSeparator/SectionSeparator.tsx";

interface IdeProps {}

const Ide: React.FC<IdeProps> = () => {
    return (
        <div className="dark:text-neutral-300 space-y-8 flex flex-col h-full">
            <div className="flex-1 space-y-4">
                <SectionSeparator>
                    <ScrapeSettings />
                </SectionSeparator>

                <SectionSeparator>
                    <Embeddings />
                </SectionSeparator>
            </div>

            {/* No save button needed as embeddings handle their own actions */}
        </div>
    );
};

export default Ide;
